<template>
  <p
    v-if="timestamp || showStatusIndicator"
    class="messageBubble-timestamp text-xs text-grey-text-subdued mt-4 flex items-center gap-4"
  >
    <MessageBubbleStatus v-if="showStatusIndicator" :status="messageStatus" :tick-size="tickSize" />
    <span v-if="timestamp">{{ timestamp }}</span>
  </p>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { MessageStatus } from '@/apps/messages/types';
import MessageBubbleStatus from './MessageBubbleStatus.vue';

export default {
  name: 'MessageBubbleTimestamp',
  components: { MessageBubbleStatus },
  props: {
    timestamp: {
      type: String,
      default: '',
    },
    isOutgoing: {
      type: Boolean,
      default: false,
    },
    messageStatus: {
      type: String as PropType<MessageStatus>,
      default: 'sent',
    },
    read: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showStatusIndicator(): boolean {
      return this.isOutgoing;
    },
    tickSize(): number {
      return 14;
    },
  },
};
</script>
